import { SectionComponentLayout } from '../layout/SectionComponentLayout.js';
import { AnalyticsProvider } from '../providers/AnalyticsProvider.js';
import { ErrorBoundary } from '../ui/ErrorBoundary.js';
import '../ui/RichText/index.js';
import { articleRichTextOptions } from '../ui/RichText/options/articleRichTextOptions.js';
import { jsx } from 'react/jsx-runtime';
import { RichText } from '../ui/RichText/RichText.js';
function CountryFooterDisclaimer({
  disclaimer,
  hasSpacingTop = true,
  hasSpacingHorizontal = true
}) {
  return /*#__PURE__*/jsx(ErrorBoundary, {
    children: /*#__PURE__*/jsx(AnalyticsProvider, {
      analyticsPrefix: "CountryFooterDisclaimer",
      children: /*#__PURE__*/jsx(SectionComponentLayout, {
        hasSpacingTop: hasSpacingTop,
        hasSpacingHorizontal: hasSpacingHorizontal,
        children: /*#__PURE__*/jsx(RichText, {
          content: disclaimer,
          richTextOptions: articleRichTextOptions
        })
      })
    })
  });
}
export { CountryFooterDisclaimer };
//# sourceMappingURL=CountryFooterDisclaimer.js.map
